import { useTranslation } from "react-i18next";
import { Body1, Subtitle1 } from "@myphx-engineering/phx-design-system";
import { jsx } from "react/jsx-runtime";
import { IllustrationCard, NoResultsIllustration } from "@phx/myphx-lib";

//#region src/client/components/consent-list/NoConsentsFoundCard.tsx
const NoConsentsFoundCard = () => {
	const { t } = useTranslation("cons");
	return /* @__PURE__ */ jsx(IllustrationCard, {
		Illustration: NoResultsIllustration,
		variant: "bare",
		illustrationPosition: "top",
		withShadow: false,
		illustrationSize: "lg",
		color: "gray",
		header: /* @__PURE__ */ jsx(Subtitle1, {
			bold: true,
			ta: "center",
			children: t("consents.filter.noResults.header")
		}),
		children: /* @__PURE__ */ jsx(Body1, { children: t("consents.filter.noResults.body") })
	});
};

//#endregion
export { NoConsentsFoundCard };